<template>
  <section class="co-bg-striped">
    <div class="co-container-md px-4 py-20">
      <h2 class="co-heading-2-caption">
        効率を最大化する<span class="block md:inline">学習サイクル</span>
      </h2>
      <h3 class="co-display-12 mb-[3.25rem] text-left leading-base md:text-center">
        自ら学習を進め、わからないことをメンターに質問する。
        <br class="hidden md:block">
        無駄のないサイクルで学習効率を最大化させます。
      </h3>
      <div class="flex flex-col md:flex-row md:gap-x-8">
        <div class="mb-8 basis-full md:mb-0 md:basis-5/12">
          <slot name="image">
            <img
              class="mx-auto w-3/4 sm:w-1/2 md:w-full"
              src="~/assets/images/Te/TeCommon/LearningCycle/cycle-develop.svg"
              loading="lazy"
              alt="学習サイクル 開発"
            >
          </slot>
        </div>
        <div class="md:basis-7/12">
          <div>
            <h4 class="co-display-10 text-center font-bold md:text-left">
              <slot name="catchOne">
                <span>カリキュラムを</span>
                <span class="text-co-primary-500">読む</span>
              </slot>
            </h4>
            <p>
              <slot name="textOne">
                <span>テックアカデミーのオンラインオリジナル学習システムを使って、自ら学習を進めていただきます。</span>
                <span>カリキュラムは最新情報をすぐにアップデートできるよう、テキストベースで作成されています。</span>
              </slot>
            </p>
          </div>
          <div class="mt-7">
            <h4 class="co-display-10 text-center font-bold md:text-left">
              <slot name="catchTwo">
                <span>Webサービスを</span>
                <span class="text-co-primary-500">開発する</span>
              </slot>
            </h4>
            <p>
              <slot name="textTwo">
                <span>知識を「学ぶ」だけでなく、実際に「使える」ようになるために、手を動かしながら実践に近い形で開発します。</span>
                <span>チュートリアル形式のカリキュラムを進めることで、開発手法を身につけます。</span>
              </slot>
            </p>
          </div>
          <div class="mt-7">
            <h4 class="co-display-10 text-center font-bold md:text-left">
              <span>疑問点をメンターに</span>
              <span class="text-co-primary-500">質問する</span>
            </h4>
            <p class="m-0">
              <slot name="textThree">
                <span>自習していてわからないところを1人で悩まずに、すぐにメンターに聞いて解決することが重要です。</span>
                <span>オンラインで常駐している現役エンジニアのメンターが、あなたの質問に素早く回答します。</span>
              </slot>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
